'use client';

import React, { useState } from 'react';
import { SectionLayout } from '@/components/shared/section-layout';
import { TabsContent } from '@/components/ui/tabs';
import { GenericTabBar } from '@/styles/GenericTabBar';
import { CostCodesTab } from './components/cost-codes-tab';
import { ItemsTab } from './components/items-tab';
import { useVisibleTabs } from '@/hooks/useVisibleTabs';
import { NothingAvailable } from '@/components/NavigationUnavailable';
import type { NavKey } from '@/lib/navigation-catalog';

// which tabs a role gets is the navigation matrix (nav_visibility), one element per tab
const TAB_KEYS: Record<string, NavKey> = { 'cost-codes': 'cost_management.catalog.tab.cost_codes', items: 'cost_management.catalog.tab.items' };
const TABS = [
  { value: 'cost-codes', label: 'Cost Codes' },
  { value: 'items', label: 'Catalog Items' },
];

/** Catalog: the company's cost codes (Parent -> Child) and the catalog items (with their vendor offers) that later modules will draw from. */
export function CatalogPage() {
  const visible = useVisibleTabs(TABS, TAB_KEYS);
  const [requestedTab, setActiveTab] = useState('cost-codes');
  const activeTab = visible.activeOf(requestedTab);

  if (activeTab === undefined) return <SectionLayout title="Catalog"><NothingAvailable message="No section of the Catalog is available for your account." /></SectionLayout>;

  return (
    <SectionLayout title="Catalog">
      <GenericTabBar tabs={visible.tabs} activeTab={activeTab} onTabChange={setActiveTab} className="space-y-6">
        {visible.has('cost-codes') && (
          <TabsContent value="cost-codes" className="space-y-6 mt-6">
            <CostCodesTab />
          </TabsContent>
        )}
        {visible.has('items') && (
          <TabsContent value="items" className="space-y-6 mt-6">
            <ItemsTab />
          </TabsContent>
        )}
      </GenericTabBar>
    </SectionLayout>
  );
}
